import { useAct } from 'FlowBuilder/store'
import InlineCkEditor from 'Shared/components/CKEditor/InlineCkEditor'
import useActionTranslate from 'FlowBuilder/hooks/useActionTranslate'
import { ActionTranslatableKeysCustom } from 'FlowBuilder/lib/actionTranslatable'

export default function CustomActionForm({ actionId }) {
  const act = useAct()

  const action = useSel(s => s.actions.entities[s.local.selectedActionId])
  const config = action.config || { content: '' }
  const mergeTags = useSel(s => s.builder.mergeTags || [])
  const [sourceModeEnabled, setSourceModeEnabled] = useState(false)

  const {
    language,
    textContentUpdater,
    translated: { skipButtonText, content },
    fallback: { skipButtonText: skipButtonTextFallback, content: contentFallback },
    flag
  } = useActionTranslate<ActionTranslatableKeysCustom>({ actionId })

  function toggleSourceMode() {
    setSourceModeEnabled(!sourceModeEnabled)
  }

  return <div className="box narrow">
    <h2 className='no-margin-top'>Custom Step</h2>
    <div className='field'>
      <label className="bold margin-top margin-bottom half">Content {flag}</label>
      <InlineCkEditor
        value={content || ''}
        placeholder={contentFallback || ''}
        sourceMode={sourceModeEnabled}
        setSourceMode={toggleSourceMode}
        onUpdate={newContent => textContentUpdater('content', newContent)}
        mergeTags={mergeTags}
        hideMergeTags={true}
      />
      <div className='flex field margin-top double'>
        <label className="bold">Show skip button</label>
        <input
          type='checkbox'
          checked={action.config.skipButton}
          onChange={(e) => act.actions.upsert(actionId, { config: { ...config, skipButton: e.target.checked } })}
          className="margin-left"
        />
      </div>
      {!action.config.skipButton &&
        <p className="margin-top half no-margin-bottom text-small">Without a skip button there is no way to move to the next step.</p>
      }
      {action.config.skipButton && <>
        <div className='flex column field margin-top'>
          <label className="bold">Skip button text {flag}</label>
          <input
            type='text'
            value={skipButtonText ?? ''}
            placeholder={skipButtonTextFallback ?? ''}
            onChange={e => textContentUpdater('skipButtonText', e.target.value)}
            className="margin-top half"
          />
        </div>
      </>}
    </div>
  </div>
}
